import { render, staticRenderFns } from "./EditPasswordByAdministrator.vue?vue&type=template&id=70896dee&"
import script from "./EditPasswordByAdministrator.vue?vue&type=script&lang=js&"
export * from "./EditPasswordByAdministrator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports